export const browser = {
  Chrome: "Chrome",
  Firefox: "Firefox",
  Safari: "Safari",
  Opera: "Opera",
  Edge: "Edge",
  InternetExplorer: "Internet Explorer",
  Unknown: "Unknown",
}
